import { PERMISSION_KEYS } from 'constants-permissions';
import { hasPermission } from 'lane-shared/helpers';
import { UserType } from 'lane-shared/types/User';

export function useServiceRequestPermissions(
  user: UserType,
  channel?: { _id: string }
) {
  const hasAttachFilesPermission =
    user?.isSuperUser ||
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_ATTACH_FILE],
      channel?._id,
      false
    );

  const isAdmin =
    user?.isSuperUser ||
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_SERVICE_REQUEST_VIEW],
      channel?._id
    );

  const isStaffUser =
    !isAdmin &&
    hasPermission(
      user?.roles,
      [PERMISSION_KEYS.PERMISSION_WORK_ORDERS_MODULE_ACCESS],
      channel?._id
    );

  return {
    hasAttachFilesPermission,
    isAdmin,
    isStaffUser,
  };
}
